import type { NavNode, NavPage } from './types'
import { cairoWallToMs } from '@shared/cairoTime'

/**
 * "NEW" in red next to a feature for its first week (owner, 2026-09-22: "so I can find where it landed"). A page sets
 * `newSince` to the Cairo day it shipped; the badge shows on the page and on every section above it, then goes by itself.
 */
export const NEW_FOR_DAYS = 7

export function isNewPage(page: Pick<NavPage, 'newSince'>, now = Date.now()) {
  if (!page.newSince) return false
  const since = cairoWallToMs(`${page.newSince}T00:00:00`)
  return Number.isFinite(since) && now >= since && now - since < NEW_FOR_DAYS * 86_400_000
}

/** A section or subsection shows NEW while any visible page inside it is new. */
export function hasNewPage(node: NavNode, now = Date.now()): boolean {
  if (node.kind === 'page') return !node.hidden && isNewPage(node, now)
  return node.children.some((c) => hasNewPage(c, now))
}
